module.exports = __webpack_public_path__ + "img/logo.506fc8eb.png";